import { isEqual as _isEqual } from 'lodash';

import type { TraffickingFiltersInput } from '../../../../../apis/graphql';
import type { GlobalFilters, OmittedCustomFiltersFields } from '../../../../../contexts/FilterContext/hooks';
import { convertFiltersToTraffickingFiltersInput } from '../../../utils';

export const getCustomFilterPayload = (
  selectedCustomFilterId: string,
  filters: GlobalFilters
): TraffickingFiltersInput => {
  const overriddenFilters: OmittedCustomFiltersFields = {
    campaigns: null,
    lineItems: null,
    ads: null,
    selectedTab: null,
    dateFilter: null,
  };

  return {
    ...convertFiltersToTraffickingFiltersInput(filters),
    ...overriddenFilters,
  };
};

const convertToDefaultValueIfEmpty = (
  value: TraffickingFiltersInput[keyof TraffickingFiltersInput]
): TraffickingFiltersInput[keyof TraffickingFiltersInput] => {
  return Array.isArray(value) && value.length === 0 ? null : value;
};

export const compareFilterInputs = (
  filterInput: TraffickingFiltersInput,
  otherFilterInput: TraffickingFiltersInput
): boolean => {
  const filterInputKeys = Object.keys(filterInput);
  const otherFilterInputKeys = Object.keys(otherFilterInput);

  if (filterInputKeys.length !== otherFilterInputKeys.length) return false;

  return filterInputKeys.every((key) => {
    const filterKey = key as keyof TraffickingFiltersInput;
    const filterInputValue = convertToDefaultValueIfEmpty(filterInput[filterKey]);
    const otherFilterInputValue = convertToDefaultValueIfEmpty(otherFilterInput[filterKey]);

    return _isEqual(filterInputValue, otherFilterInputValue);
  });
};
